import { CUSTOM_STATUS_COLORS } from '@/common/item-statuses/item-statuses.constants.js';
import { http } from '@pendo/http';
import pick from 'lodash/pick';

export function injectColorsStatus (statuses, type = 'idea') {
    const updatedStatuses = statuses.map((status) => {
        const pickedStatus = pick(status, ['id', 'name', 'displayOrder', 'color', 'deletePending']);

        /* eslint-disable internal-rules/no-hardcoded-colors */
        const statusColorObj = status.color ? CUSTOM_STATUS_COLORS[status.color] : CUSTOM_STATUS_COLORS['#028CC2'];

        return {
            ...pickedStatus,
            type,
            style: statusColorObj,
        };
    });

    return updatedStatuses;
}

export function fetchStatuses (type) {
    let endpoint;
    switch (type) {
        case 'feedback':
            endpoint = 'vocItemFeedback';
            break;
        case 'idea':
            endpoint = 'vocItem';
            break;
        default:
            endpoint = type;
            break;
    }

    return http.get(`api/s/_SID_/status/${endpoint}`).then((res) => res.data);
}

export function createStatus ({ name, color, statusType }) {
    return http
        .post(`api/s/_SID_/status/${statusType}`, {
            name,
            color,
        })
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function updateStatus ({ id, name, color, statusType }) {
    return http
        .put(`api/s/_SID_/status/${statusType}/${id}`, {
            name,
            color,
        })
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function reorderStatuses ({ statusIds, vocItemType }) {
    const statusType = vocItemType === 'idea' ? 'vocItem' : 'vocItemFeedback';

    return http
        .put(`api/s/_SID_/status/${statusType}/reorder`, {
            order: statusIds,
        })
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function deleteStatus ({ type, statusIdToDelete, statusIdToAssignTo }) {
    return http
        .put(`api/s/_SID_/status/${type}/delete`, {
            statusIdToDelete,
            statusIdToAssignTo,
        })
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}
